<template>
	<div class="shopaccess">
		<!-- 卖家备注名称 -->
		<el-dialog :title="$t('other.a2342')" :visible.sync="addressDia" width="70%">
			<el-table size='mini' :data="addressData" border style="width: 100%">
				<el-table-column prop="country" label="type">
					<template slot-scope="props">
						<div v-if="!props.row.address_type">{{ $t('other.a2360') }}</div>
						<div v-if="props.row.address_type" v-for="(item, index) in props.row.address_type" :key="index">
							<span>{{ item ? item : $t('other.a2360') }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="address" label="address">
					<template slot-scope="props">
						<span>{{ props.row.region }}/</span>
						<span>{{ props.row.state }}/</span>
						<span>{{ props.row.city }}/</span>
						<span>{{ props.row.address }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="zipcode" label="zipcode">
				</el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addressDia = false">{{ $t('other.a5') }}</el-button>
			</span>
		</el-dialog>
		<!-- 卖家备注名称 -->
		<el-dialog :title="$t('other.a2343')" :visible.sync="remarkDia" width="30%">
			<el-input v-model="remarkName" :placeholder="$t('other.a2284')"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="remarkDia = false">{{ $t('other.a106') }}</el-button>
				<el-button type="primary" @click="comfirmRemark()">{{ $t('other.a279') }}</el-button>
			</span>
		</el-dialog>
		<!-- 采购员帐号详情（最多只能创建3个私有仓的帐号） -->
		<el-dialog :title="$t('other.a1450')" :visible.sync="purchaseDia" width="50%">
			<div style="margin-bottom:20px;flot:right">
				<el-button size="small" type="primary" @click="buyerDia = true">{{ $t('other.a1453') }}</el-button>
			</div>
			<el-table border :data="purchaseList" style="width: 100%">
				<el-table-column prop="userId" :label="$t('other.a1451')">
				</el-table-column>
				<el-table-column prop="userName" :label="$t('other.a1452')">
				</el-table-column>
				<el-table-column :label="$t('other.a57')">
					<template slot-scope="props">
						<span>{{ getTime(props.row.createTime) }}</span>
					</template>
				</el-table-column>
			</el-table>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="purchaseDia = false">{{ $t('shopaccess.cancel') }}</el-button>
			</span>
		</el-dialog>
		<!-- 新增采购员 -->
		<el-dialog :title="$t('other.a1456')" :visible.sync="buyerDia" width="30%">
			<el-form :model="buyUser" ref="buyUser" label-width="110px" class="demo-dynamic">
				<el-form-item prop="userName" :label="$t('other.a1452')"
					:rules="[{ required: true, message: $t('other.a1460'), trigger: 'blur' }]">
					<el-input size="medium" v-model="buyUser.userName" :placeholder="$t('other.a1457')"></el-input>
				</el-form-item>
				<el-form-item prop="password" :label="$t('other.a464')"
					:rules="[{ required: true, message: $t('other.a1461'), trigger: 'blur' }]">
					<el-input size="medium" type="password" v-model="buyUser.password"
						:placeholder="$t('other.a1458')"></el-input>
				</el-form-item>
				<el-form-item prop="secondpassword" :label="$t('other.a431')"
					:rules="[{ required: true, message: $t('other.a1461'), trigger: 'blur' }]">
					<el-input size="medium" type="password" v-model="buyUser.secondpassword"
						:placeholder="$t('other.a1459')"></el-input>
				</el-form-item>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="buyerDia = false">{{ $t('other.a106') }}</el-button>
				<el-button type="primary" @click="createBuyerAccount()">{{ $t('other.a279') }}</el-button>
			</span>
		</el-dialog>
		<!-- 授权shopify -->
		<el-dialog :title="$t('other.a2344')" :visible.sync="authorizeShopifyDia" width="30%">
			<el-form :model="shopifyForm" ref="shopifyForm" label-width="80px" class="demo-dynamic">
				<el-form-item prop="shopName" :label="$t('other.a2345')"
					:rules="[{ required: true, message: $t('other.a2361'), trigger: 'blur' }]">
					<el-input size="medium" v-model="shopifyForm.shopName"></el-input>
				</el-form-item>
				<el-form-item prop="shop" size="medium" :label="$t('other.a2346')"
					:rules="[{ required: true, message: $t('other.a2362'), trigger: 'blur' }]">
					<el-input :placeholder="$t('other.a319')" v-model="shopifyForm.shop">
						<template slot="prepend">Https://</template>
						<template slot="append">.com</template>
					</el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="authorizeShopifyDia = false">{{ $t('other.a106') }}</el-button>
				<el-button type="primary" @click="getShopAuthorization_shopify()">{{ $t('other.a279') }}</el-button>
			</span>
		</el-dialog>
		<!-- 私有仓帐号详情（最多只能创建3个私有仓的帐号） -->
		<el-dialog :title="$t('other.a2347')" :visible.sync="DiaLogPrivateStore" width="50%">
			<div style="margin-bottom:20px;flot:right">
				<el-button size="small" type="primary" @click="dialogVisible04 = true">{{ $t('other.a2363') }}</el-button>
			</div>
			<el-table border :data="privateStoreList" style="width: 100%">
				<el-table-column prop="storeUserId" :label="$t('other.a2290')" width="180">
				</el-table-column>
				<el-table-column :label="$t('other.a57')">
					<template slot-scope="props">
						<span>{{ getTime(props.row.createTime) }}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('other.a33')">
					<template slot-scope="props">
						<!-- <el-button size="mini" type="primary" @click="createDistributeStore(0,props.row)">{{$t('other.a2291')}}</el-button> -->
						<el-button size="mini" type="primary" @click="createDistributeStore(1, props.row)">{{
							$t('other.a2292') }}</el-button>
					</template>
				</el-table-column>
			</el-table>

			<span slot="footer" class="dialog-footer">

				<el-button type="primary" @click="DiaLogPrivateStore = false">{{ $t('shopaccess.cancel') }}</el-button>
			</span>
		</el-dialog>

		<!-- 卖家用户新建分销子仓 -->
		<el-dialog :title="$t('other.a2348')" :visible.sync="distributeStoreDia" width="30%">
			<el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
				<el-form-item :label="$t('other.a2230')" prop="store.storeAddress">
					<el-select v-model="ruleForm.store.storeAddress" :placeholder="$t('other.a50')">
						<el-option v-for="item in countryOption" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="!isChildrenStore" :label="$t('other.a2349')" prop="store.storeName">
					<el-input v-model="ruleForm.store.storeName"></el-input>
				</el-form-item>
				<el-form-item v-if="isChildrenStore" :label="$t('other.a2350')" prop="store.storeName">
					<el-input v-model="ruleForm.store.storeName"></el-input>
				</el-form-item>
				<el-form-item v-if="!isChildrenStore" :label="$t('other.a518')" prop="store.address.name">
					<el-input v-model="ruleForm.store.address.name"></el-input>
				</el-form-item>

				<el-form-item v-if="!isChildrenStore" :label="$t('other.a519')" prop="store.address.phone">
					<el-input v-model="ruleForm.store.address.phone"></el-input>
				</el-form-item>
				<el-form-item v-if="!isChildrenStore" :label="$t('other.a517')" prop="store.address.address">
					<el-input type="textarea" :rows="2" :placeholder="$t('other.a2351')"
						v-model="ruleForm.store.address.address">
					</el-input>
				</el-form-item>
				<el-form-item v-if="!isChildrenStore" :label="$t('other.a2353')" prop="applyDec">
					<el-input type="textarea" :rows="2" :placeholder="$t('other.a2352')" v-model="ruleForm.applyDec">
					</el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="distributeStoreDia = false">{{ $t('other.a106') }}</el-button>
				<el-button type="primary" @click="generateDistrubuteStore()">{{ $t('other.a279') }}</el-button>
			</span>
		</el-dialog>

		<!-- 注册私有仓用户 -->
		<el-dialog :title="$t('other.a2354')" :visible.sync="dialogVisible04" width="30%">

			<!-- <div class="ilnv">
			<div class="gknv">
				<img style="width:100%" src="../../assets/img/kefu.png" />
			</div>
		
		</div> -->
			<div style="font-size:14px;font-weight:bold;color:red;margin-bottom:15px">
				{{ $t('other.a2364') }}
			</div>
			<el-select style="width:100%;margin-bottom:20px" v-model="newObj.country" :placeholder="$t('other.a644')">
				<el-option v-for="item in countryOption" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<el-input style="margin-bottom:20px" :placeholder="$t('other.a2355')" v-model="newObj.storeName" clearable>
			</el-input>
			<el-input style="margin-bottom:20px" type="password" :placeholder="$t('other.a2356')" v-model="newObj.password"
				clearable> </el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible04 = false">{{ $t('other.a5') }}</el-button>
				<el-button type="primary" @click="registore()">{{ $t('other.a279') }}</el-button>
			</span>
		</el-dialog>
		<el-scrollbar>

			<!-- 卖家帐号查看仓库收费规则 弹窗-->
			<el-dialog :title="$t('other.a2357')" :visible.sync="storeCharge" width="30%">
				<div v-show="rechargeRulse ? rechargeRulse[0].storeType == 2 : false"
					style="font-size:18px;line-height:35px;height:350px;overflow-y: auto">
					<div>{{ $t('other.a914') }}：{{ rechargeRulse ? storeTypeNum[rechargeRulse[0].storeType] :
						$t('other.a354') }}</div>
					<div>{{ $t('other.a2365') }}：{{ rechargeRulse ? rechargeRulse[0].chargeRule.fee : $t('other.a354') }}
						RMB
					</div>
					<div>{{ $t('other.a2366') }}：{{ rechargeRulse ? rechargeRulse[0].chargeRule.amountLimit :
						$t('other.a354') }} {{ $t('other.a1337') }}</div>
				</div>
				<div v-show="rechargeRulse ? rechargeRulse[0].storeType == 1 : false"
					style="font-size:16px;line-height:30px;heigth:250px;overflow-y: auto">
					<div class="recharge_item">{{ $t('other.a914') }}：{{ rechargeRulse ?
						storeTypeNum[rechargeRulse[0].storeType] : $t('other.a354') }} </div>
					<!-- <div class="recharge_item">{{$t('other.a1874')}}：{{rechargeRulse ? rechargeRulse[0].chargeRule.materialIntegral : $t('other.a354')}} {{$t('other.a54')}}</div> -->
					<div class="recharge_item">{{ $t('other.a2367') }}：{{ rechargeRulse ?
						rechargeRulse[0].chargeRule.returnIntegral : $t('other.a354') }}</div>
					<div class="recharge_item">{{ $t('other.a2368') }}：{{ rechargeRulse ?
						rechargeRulse[0].chargeRule.skuAmount
						: $t('other.a354') }} {{ $t('other.a2093') }}</div>
					<div class="recharge_item">{{ $t('other.a2369') }}：{{ rechargeRulse ?
						rechargeRulse[0].chargeRule.skuIntegral : $t('other.a354') }}
						{{ $t('other.a54') }}/{{ $t('other.a2093') }}</div>
					<div class="recharge_item">{{ $t('other.a2370') }}：{{ rechargeRulse ?
						rechargeRulse[0].chargeRule.skuPiece :
						$t('other.a354') }} {{ $t('other.a2093') }}</div>
					<div class="recharge_item">{{ $t('other.a2371') }}：{{ rechargeRulse ?
						rechargeRulse[0].chargeRule.skuPieceIntegral : $t('other.a354') }}
						{{ $t('other.a54') }}/{{ $t('other.a2093') }}</div>
					<div class="recharge_item">{{ $t('other.a2298') }}：
						<div style="padding-left:20px"
							v-for="(item, index) in rechargeRulse ? rechargeRulse[0].chargeRule.serviceRuleItems : []"
							:key="index">
							<span>{{ item.weight }}kg</span> &nbsp;<span>{{ item.storeIntegralFee }}{{ $t('other.a54')
							}}</span>
						</div>
					</div>
					<div class="recharge_item">{{ $t('other.a1875') }}：
						<div style="padding-left:20px"
							v-for="(item, index) in rechargeRulse ? rechargeRulse[0].chargeRule.shelvesRuleItems : []"
							:key="index">
							<span>{{ item.weight }}kg</span> &nbsp;<span>{{ item.storeIntegralFee }}{{ $t('other.a54')
							}}</span>
						</div>
					</div>
					<div class="recharge_item">{{ $t('other.a1874') }}：
						<div style="padding-left:20px"
							v-for="(item, index) in rechargeRulse ? rechargeRulse[0].chargeRule.volumeRuleItems : []"
							:key="index">
							<span>{{ item.volume }} cm³</span> &nbsp;<span>{{ item.storeIntegral }}{{ $t('other.a54')
							}}</span>
						</div>
					</div>
				</div>

				<div v-show="rechargeRulse ? rechargeRulse[0].storeType == 0 : false"
					style="font-size:16px;line-height:30px">
					<div class="recharge_item">{{ $t('other.a914') }}：{{ rechargeRulse ?
						storeTypeNum[rechargeRulse[0].storeType] : $t('other.a354') }} </div>
					<div class="recharge_item">{{ $t('other.a2372') }}：{{ rechargeRulse ?
						rechargeRulse[0].chargeRule.billsCost
						: $t('other.a354') }} {{ $t('other.a54') }}</div>
					<div class="recharge_item">{{ $t('other.a2373') }}：{{ rechargeRulse ?
						rechargeRulse[0].chargeRule.operationCost : $t('other.a354') }} {{ $t('other.a54') }}</div>
					<div class="recharge_item"
						v-for="(item, index) in rechargeRulse ? rechargeRulse[0].chargeRule.goodsChargeList : []"
						:key="index">
						<span>{{ item.goodsDesc }}：</span> <span>{{ item.goodsChargeFee }}{{ $t('other.a54') }}</span>
					</div>
				</div>


				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="storeCharge = false">{{ $t('other.a5') }}</el-button>
				</span>
			</el-dialog>
			<!-- TEMU修改/新增 -->
			<el-dialog class="teDialog"
				:title="!TEMUFormData.id ? ($t('other.a1448') + 'TEMU' + $t('chat.Authorizedshops')) : ($t('other.a93') + 'TEMU' + $t('chat.Authorizedshops'))"
				:visible.sync="dialogFormVisibleTEMU" :close-on-click-modal="false">
				<el-form class="teForm" :model="TEMUFormData" ref="TEMURules" :rules="TEMURules" label-width="140px">
					<!-- <el-form-item :label="$t('shopaccess.shopId')" prop="shopId">
						<el-input v-model="TEMUFormData.shopId" :disabled="TEMUFormData.id"></el-input>
					</el-form-item> -->
					<el-form-item :label="$t('shopaccess.shopName')" prop="shopName">
						<el-input v-model="TEMUFormData.shopName"></el-input>
					</el-form-item>
					<el-form-item label="授权类型" prop="authType">
						<el-select v-model="TEMUFormData.authType">
							<el-option :label="item.label" :value="item.value" v-for="(item) in TEMUAuthType"
								:key="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('shopaccess.shopSite')" prop="shopSite">
						<el-select v-model="TEMUFormData.shopSite">
							<el-option :label="item.label" :value="item.value" v-for="(item) in TEMUSite"
								:key="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('other.a2166')" prop="shopType">
						<el-select v-model="TEMUFormData.shopType">
							<el-option :label="item.label" :value="item.value" v-for="(item) in TEMUType"
								:key="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('other.a3330')" prop="productToken" v-if="TEMUFormData.shopType != '2'">
						<el-input v-model="TEMUFormData.productToken"></el-input>
					</el-form-item>
					<el-form-item :label="$t('other.a3331')" prop="usOrderToken" v-if="TEMUFormData.shopType != '2'">
						<el-input v-model="TEMUFormData.usOrderToken"></el-input>
					</el-form-item>
					<el-form-item :label="$t('other.a3332')" prop="euOrderToken" v-if="TEMUFormData.shopType != '2'">
						<el-input v-model="TEMUFormData.euOrderToken"></el-input>
					</el-form-item>
					<el-form-item label="订单应用Key" prop="orderAppKey" v-if="TEMUFormData.authType == '1'">
						<el-input v-model="TEMUFormData.orderAppKey"></el-input>
					</el-form-item>
					<el-form-item label="订单应用Secret" prop="orderAppSecret" v-if="TEMUFormData.authType == '1'">
						<el-input v-model="TEMUFormData.orderAppSecret"></el-input>
					</el-form-item>
					<el-form-item label="产品应用Key" prop="productAppKey" v-if="TEMUFormData.authType == '1'">
						<el-input v-model="TEMUFormData.productAppKey"></el-input>
					</el-form-item>
					<el-form-item label="产品应用Secret" prop="productAppSecret" v-if="TEMUFormData.authType == '1'">
						<el-input v-model="TEMUFormData.productAppSecret"></el-input>
					</el-form-item>
					<el-form-item :label="$t('other.a3333')" prop="shopCurrency" v-if="TEMUFormData.shopType != '2'">
						<el-select v-model="TEMUFormData.shopCurrency">
							<el-option :label="item.label" :value="item.value" v-for="(item) in TEMUCurrency"
								:key="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="授权Token令牌" prop="localToken" v-if="TEMUFormData.shopType == '2'">
						<el-input v-model="TEMUFormData.localToken"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogFormVisibleTEMU = false">{{ $t('other.a106') }}</el-button>
					<el-button type="primary" @click="changeTEMU('TEMURules')">{{ $t('other.a279') }}</el-button>
				</div>
			</el-dialog>


			<AuthorizedStore @changAuthoriedStore="changAuthoriedStore"></AuthorizedStore>
			<div class="main-header">

				<div>
					<span class="shop-desc" v-if="userPos === 'SELLER'" @click="getPurchaser()">{{ $t('other.a2374')
					}}</span>
					<!-- <span class="shop-desc" v-if="userPos === 'SELLER' " @click="authorizeShopifyDia=true">{{$t('shopaccess.shopify')}}</span> -->
					<!-- <span class="shop-desc" v-if="userPos === 'SELLER' " @click="getShopAuthorization_lazada">{{$t('shopaccess.bindshop_LAZADA')}}</span>
				 <span class="shop-desc" v-if="userPos === 'SELLER' && userId !== 'dianxiaosheng@weanaly.com' " @click="openAuthorization()">{{$t('shopaccess.bindshop')}}</span>
				 <span class="shop-desc" v-if=" userId == 'dianxiaosheng@weanaly.com' " @click="openAuthorizationCopy">{{$t('shopaccess.bindshop')}}</span> -->
					<span class="shop-desc" v-if="userPos === 'SELLER' && level !== 5" @click="viewPrivateAccount()">{{
						$t('other.a2375') }}</span>
					<el-tooltip v-if="userPos === 'SELLER' && level !== 5" style="margin-right:15px" effect="light"
						:content="$t('other.a2376')" placement="bottom">
						<i class="el-icon-question" style="font-size:22px"></i>
					</el-tooltip>
				</div>
			</div>

			<div class="shop-detail" v-if="userPos === 'SELLER'">
				<div class="shop-detail-title">shopee{{ $t('other.a1674') }}<span class="kvhnkf">
						({{ $t('other.a2377') }}/{{ $t('other.a2378') }})</span></div>
				<div class="shop-item-title">
					<span class="title-item">{{ $t('shopaccess.shopId') }}</span>
					<span class="title-item">{{ $t('shopaccess.shopName') }}</span>
					<span class="title-item">{{ $t('shopaccess.shopSite') }}</span>
					<!-- <span class="title-item">{{$t('shopaccess.shopStatus')}}</span> -->
					<span class="title-item">{{ $t('other.a2379') }}</span>
					<!-- <span class="title-item">{{$t('shopaccess.Expiredate')}}</span> -->
					<span class="title-item">{{ $t('shopaccess.operate') }}</span>
				</div>
				<div v-if="!shopList" style="width: 100%;text-align: center;padding: 20px 0;">
					--{{ $t('other.a2380') }}--</div>
				<div v-else class="shop-item-list" v-for="(item, index) in shopList" :key='index'>
					<span class="list-item">{{ item.shopId }}</span>
					<span class="list-item">{{ item.shopName }} <i class="el-icon-edit"
							@click="kvhmf(item.shopId)"></i></span>
					<span class="list-item">{{ getCountry(item.country) }}</span>
					<!-- <span class="list-item">{{getStatus(item.status)}}</span> -->
					<!-- <span class="list-item">{{showStatus(item.authTime,item.expireTime)}}</span> -->
					<span class="list-item">
						<span class="omog" v-if="!showStatus(item.authTime, item.expireTime)"><span
								class="lgkjg"></span><span class="uijk">{{ $t('other.a1642') }}</span></span>
						<span class="omog" v-if="showStatus(item.authTime, item.expireTime)"><span class="ehng"></span><span
								class="uijk">{{ $t('other.a1082') }}</span></span>
					</span>
					<!-- <span class="list-item">{{getTime(item.authTime)}}</span>
				<span class="list-item">{{getTime(item.expireTime)}}</span> -->
					<span class="list-item btn">
						<div><el-button style="width:100px;" size="mini" type="danger"
								@click="unboundshopByselleer(item.shopId)">{{ $t('shopaccess.Untie') }}</el-button></div>
						<div><el-button style="width:100px;margin-top:5px" size="mini" type="primary"
								@click="getShopAddress(item.shopId)">{{ $t('other.a2381') }}</el-button></div>
					</span>
				</div>
			</div>

			<div class="shop-detail" v-if="userPos === 'SELLER'">
				<div class="shop-detail-title">TikTok Shop{{ $t('other.a1674') }}<span class="kvhnkf">
						({{ $t('other.a2377') }}/{{ $t('other.a2378') }})</span></div>
				<div class="shop-item-title">
					<span class="title-item">{{ $t('shopaccess.lazada_shortCode') }}</span>
					<span class="title-item">{{ $t('shopaccess.lazada_name') }}</span>
					<span class="title-item">{{ $t('shopaccess.shopSite') }}</span>
					<span class="title-item">{{ $t('other.a2379') }}</span>
					<span class="title-item">{{ $t('shopaccess.lazada_location') }}</span>
					<!-- <span class="title-item">{{$t('shopaccess.operate')}}</span> -->
					<!-- <span class="title-item">{{$t('shopaccess.accessTime')}}</span> -->
					<span class="title-item">{{ $t('shopaccess.operate') }}</span>
				</div>
				<div v-if="!tiktokShops" style="width: 100%;text-align: center;padding: 20px 0;">--{{ $t('other.a2380') }}--
				</div>
				<div v-else class="shop-item-list" v-for="(item, index) in tiktokShops" :key='index'>
					<span class="list-item">{{ item.shopId }}</span>
					<span class="list-item">{{ item.shopName }}</span>
					<span class="list-item">{{ getCountry(item.region) }}</span>
					<span class="list-item">{{ getTime(item.createTime) }}</span>
					<span class="list-item">{{ item.location }}</span>
					<span class="list-item "><el-button size="mini" type="danger"
							@click="unboundshopByselleer(item.shopId)">{{ $t('shopaccess.Untie') }}</el-button></span>
				</div>
			</div>

			<div class="shop-detail" v-if="userPos === 'SELLER'">
				<div class="shop-detail-title">LAZADA{{ $t('other.a1674') }}<span class="kvhnkf">
						({{ $t('other.a2377') }}/{{ $t('other.a2378') }})</span></div>
				<div class="shop-item-title">
					<span class="title-item">{{ $t('shopaccess.lazada_shortCode') }}</span>
					<span class="title-item">{{ $t('shopaccess.lazada_name') }}</span>
					<span class="title-item">{{ $t('shopaccess.lazada_account') }}</span>
					<span class="title-item">{{ $t('other.a2379') }}</span>
					<span class="title-item">{{ $t('shopaccess.lazada_location') }}</span>
					<!-- <span class="title-item">{{$t('shopaccess.operate')}}</span> -->
					<!-- <span class="title-item">{{$t('shopaccess.accessTime')}}</span> -->
					<span class="title-item">{{ $t('shopaccess.operate') }}</span>
				</div>
				<div v-if="!lazadashopinfo" style="width: 100%;text-align: center;padding: 20px 0;">
					--{{ $t('other.a2380') }}--</div>
				<div v-else class="shop-item-list" v-for="(item, index) in lazadashopinfo" :key='index'>
					<span class="list-item">{{ item.sellerId }}</span>
					<span class="list-item">{{ item.name }}</span>
					<span class="list-item">{{ item.account }}</span>

					<span class="list-item">
						<span class="omog" v-if="!item.tokenActive"><span class="lgkjg"></span><span class="uijk">{{
							$t('other.a1642') }}</span></span>
						<span class="omog" v-if="item.tokenActive"><span class="ehng"></span><span class="uijk">{{
							$t('other.a1082') }}</span></span>
					</span>
					<span class="list-item">{{ item.location }}</span>
					<span class="list-item "><el-button size="mini" type="danger"
							@click="unboundshopByselleer(item.sellerId)">{{ $t('shopaccess.Untie') }}</el-button></span>
				</div>
			</div>

			<!-- TEMU -->
			<div class="shop-detail" v-if="userPos === 'SELLER'">
				<div class="shop-detail-title">TEMU{{ $t('other.a1674') }}<span class="kvhnkf">
						({{ $t('other.a2377') }}/{{ $t('other.a2378') }})</span></div>
				<div class="shop-item-title">
					<span class="title-item">{{ $t('shopaccess.shopId') }}</span>
					<span class="title-item">{{ $t('shopaccess.shopName') }}</span>
					<span class="title-item">{{ $t('shopaccess.shopSite') }}</span>
					<!-- <span class="title-item">{{$t('other.a2379')}}</span> -->
					<span class="title-item">{{ $t('shopaccess.operate') }}</span>
				</div>
				<div v-if="!temuAuth" style="width: 100%;text-align: center;padding: 20px 0;">
					--{{ $t('other.a2380') }}--</div>
				<div v-else class="shop-item-list" v-for="(item, index) in temuAuth" :key='index'>
					<span class="list-item">{{ item.shopId }}</span>
					<span class="list-item">{{ item.shopName }} </span>
					<span class="list-item">{{ getTemuCountry(item.shopSite) }}</span>
					<!-- <span class="list-item">
					<span class="omog" v-if="!showStatus(item.authTime,item.expireTime)"><span class="lgkjg"></span><span class="uijk">{{$t('other.a1642')}}</span></span>
					<span class="omog" v-if="showStatus(item.authTime,item.expireTime)"><span class="ehng"></span><span class="uijk">{{$t('other.a1082')}}</span></span>
				</span> -->
					<span class="list-item btn">
						<div><el-button style="width:100px;" size="mini" type="danger" @click="delShopTEMUID(item)">{{
							$t('shopaccess.Untie') }}</el-button></div>
						<div><el-button style="width:100px;margin-top:5px" size="mini" type="primary"
								@click="editShopTEMU(item)">{{ $t('other.a3329') }}</el-button></div>
					</span>
				</div>
			</div>


			<div class="shop-detail" v-if="userPos === 'SELLER'">
				<div class="shop-item-title">
					<span class="title-item">{{ $t('shopaccess.storeName') }}</span>
					<span class="title-item">{{ $t('other.a914') }}</span>
					<span class="title-item">{{ $t('shopaccess.storeAdresse') }}</span>
					<span class="title-item">{{ $t('other.a2382') }}</span>
					<span class="title-item">{{ $t('other.a2358') }}/{{ $t('other.a2359') }}
						<el-tooltip v-if="userPos === 'SELLER' && level !== 5" style="margin-right:15px" effect="light"
							:content="$t('other.a2383')" placement="bottom">
							<i class="el-icon-question" style="font-size:22px"></i>
						</el-tooltip>
					</span>

				</div>
				<div v-if="!warehouse" style="width: 100%;text-align: center;padding: 20px 0;">
					--{{ $t('other.a2301') }}--</div>
				<div v-else class="shop-item-list" v-for="(item, index) in warehouse" :key=index>
					<span class="list-item">{{ item.storeName }}</span>
					<span class="list-item">{{ storeTypeNum[item.storeType] }}</span>
					<span class="list-item">{{ getCountry(item.storeAddress) }}</span>
					<span class="list-item">
						<el-button type="primary" size="mini" @click="getRules(item.storeId)">{{ $t('other.a2384')
						}}</el-button>
					</span>
					<span class="list-item">
						<el-switch @change="changeUser(item)" v-model="item.isUsed" :active-text="$t('other.a2358')"
							in:inactive-text="$t('other.a2359')">
						</el-switch>
					</span>
				</div>

			</div>

		</el-scrollbar>

	</div>
</template>

<script>
import QrcodeDialog from '../../components/dialog/qrcodeDialog.vue'
import config from './config'
import shopaccessApi from '../../api/moudles/shopaccess.js'
import echarts from 'echarts'
import Dialog from '../../components/dialog/dialog.vue'
import md5 from 'js-md5';
import accountApi from '../../api/moudles/account'
import api2 from '../../api/api'
import api from '../../api/moudles/deduction'
import utils from '../../utils/utils.js'
import { mapState, mapActions, mapMutations } from 'vuex'

import temu from '../../api/moudles/temu'
import jsonp from '../../api/jsonp'

export default {
	bebforeRouterEnter(to, from, next) {
		from.meta.keepAlive = false
	},
	data() {
		return {
			...config,
			boundDesc: '',
			showband: false,
			discount: false,
			storeType: null,
			sellerId: JSON.parse(JSON.stringify('userInfo')).sellerId,
			activeNum: -1,
			buyerDia: false,
			viewDiscount: false,
			sellerDiscountList: [],
			storeBindShopList: [],
			remarkName: null,
			remarkDia: false,
			purchaseDia: false,
			countryOption: [],
			dialogVisible05: false,
			warehoseValue: null,
			storeCharge: false,
			addressDia: false,
			purchaseList: [],
			rechargeRulse: null,
			shopifyForm: {
				shop: null,
				shopName: null,
				userId: JSON.parse(localStorage.getItem('userInfo')).userId
			},
			DiaLogPrivateStore: false,
			distributeStoreDia: false,
			authorizeShopifyDia: false,
			storeTypeNum: [this.$t('other.a1893'), this.$t('other.a1894'), this.$t('other.a1895'), this.$t('other.a1896'), this.$t('other.a1897')],
			sellerId: null,
			privateStoreList: [],
			addressData: [],
			textDesc: '',
			invitationCode: null,
			invitationScan: null,
			isChildrenStore: false,
			indexOne: null,
			storeOption: JSON.parse(localStorage.getItem('userInfo')).stores,
			form: {
				discountType: '0',
				rate: null,
				seller: '',
				sellerId: null,
				storeId: null,
				viewDiscount: false,
				userId: JSON.parse(localStorage.getItem('userInfo')).userId
			},
			remarkParams: {},
			endTime: null,
			ruleForm: {
				applyDec: null,
				permit: 0,
				storeId: null,
				userId: JSON.parse(localStorage.getItem('userInfo')).userId,
				storeUserId: null,
				store: {
					address: {
						address: null,
						city: null,
						name: null,
						phone: null,
						state: null,
					},
					storeAddress: null,
					storeName: null
				}
			},
			rules: {
				applyDec: [
					{ required: true, message: this.$t('other.a2305'), trigger: 'blur' },
				],


				'store.storeAddress': [
					{ required: true, message: this.$t('other.a644'), trigger: 'blur' }
				],
				'storeUserId': [
					{ required: true, message: this.$t('other.a2295'), trigger: 'blur' }
				],
				'store.address.address': [
					{ required: true, message: this.$t('other.a2306'), trigger: 'blur' }
				],
				'store.address.name': [
					{ required: true, message: this.$t('other.a2307'), trigger: 'blur' }
				],
				'store.address.phone': [
					{ required: true, message: this.$t('other.a2308'), trigger: 'blur' }
				],
				'store.storeName': [
					{ required: true, message: this.$t('other.a2309'), trigger: 'blur' }
				],

			},
			privatedStoreOption: [],
			newObj: {
				country: null,
				password: null,
				storeName: null,
				userId: JSON.parse(localStorage.getItem('userInfo')).userId
			},
			buyUser: {
				password: null,
				userId: JSON.parse(localStorage.getItem('userInfo')).userId,
				userName: null,
				secondpassword: null
			},
			dialogFormVisibleTEMU: false,//TEMU弹窗
			TEMUFormData: {
				shopId: '',
				shopName: '',
				shopSite: '0',
				shopType: '0',
				productToken: '',
				usOrderToken: '',
				euOrderToken: '',
				shopCurrency: '0',
				orderAppKey: "", //订单应用Key
				orderAppSecret: "", //订单应用Secret
				productAppKey: "", //产品应用Key
				productAppSecret: "", //产品应用Secret
				authType: 1, //授权类型:0-三方,1-自研
				localToken:"",//授权Token令牌
			},//TEMU弹窗数据
			TEMURules: {
				// shopId: [
				// 	{ required: true, message: this.$t('other.a3334'), trigger: 'blur' },
				// ],
				shopName: [
					{ required: true, message: this.$t('other.a3335'), trigger: 'blur' },
				],
				shopType: [
					{ required: true, message: this.$t('other.a3336'), trigger: 'blur' },
				],
				authType: [
					{ required: true, message: this.$t('other.a3336'), trigger: 'blur' },
				]
			},
			TEMUSite: [{
				value: "0",
				label: this.$t('other.a3337')
			}, {
				value: "1",
				label: this.$t('other.a3338')
			}, {
				value: "2",
				label: this.$t('other.a3339')
			}, {
				value: "3",
				label: this.$t('other.a3340')
			}, {
				value: "4",
				label: this.$t('other.a3341')
			}, {
				value: "5",
				label: this.$t('other.a3342')
			}],
			TEMUType: [{
				value: "0",
				label: this.$t('other.a3343')
			}, {
				value: "1",
				label: this.$t('other.a3344')
			}, {
				value: "2",
				label: this.$t('other.a3345')
			}],
			TEMUCurrency: [{
				value: "0",
				label: "CNY"
			}, {
				value: "1",
				label: "USD" + this.$t('other.a3346')
			}, {
				value: "2",
				label: "USD" + this.$t('other.a3347')
			}],
			TEMUAuthType: [{
				value: "0",
				label: "三方"
			}, {
				value: "1",
				label: "自研"
			}],
		}
	},

	computed: {
		...mapState({
			userId: state => state.login.userInfo.userId || '',
			country: state => state.login.userInfo.country,
			shopList: state => state.shopaccess.shopInfo || null,
			warehouse: state => state.shopaccess.warehouse || null,
			userPos: state => state.login.userInfo.userPos || '',
			Successed: state => state.shopaccess.Successed,
			sistemAllstore: state => state.shopaccess.sistemAllstore,
			lazadashopinfo: state => state.shopaccess.lazadashopinfo || null,
			tiktokShops: state => state.shopaccess.tiktokShops || null,
			temuAuth: state => state.shopaccess.temuAuth || null,

		}),

	},
	components: {
		QrcodeDialog,
		Dialog,
		AuthorizedStore: () => import(`./components/authoriedStore`),
	},
	watch: {
		buyerDia() {
			if (!this.buyerDia) {
				this.buyUser.userName = null
				this.buyUser.password = null
				this.buyUser.secondpassword = null
			}
		},
		storeAccount() {
			if (!this.storeAccount) {
				this.activeNum = -1
			}
		},
		authorizeShopifyDia() {
			if (!this.authorizeShopifyDia) {
				this.shopifyForm.shop = null
				this.shopifyForm.shopName = null
			}
		},

		dialogVisible04() {
			if (!this.dialogVisible04) {
				this.storeAccount = ''
				this.warehouseName = ''
				this.password = ''
				this.password01 = ''
			}
		},
		dialogVisible05() {
			if (!this.dialogVisible05) {
				this.invitationScan = ''

			}
		},
		Successed() {
			this.upDatePages()
		},
		showChare() {
			if (!this.showChare) {
				// this.init()
				this.chooseStoreAll = false
				this.chooseAll = false
			}
		},
		dialogVisible02() {
			if (!this.dialogVisible02) {
				this.userName = ""
				this.storeName = ""
				this.value = ""
			}


		},
		distributeStoreDia() {
			if (!this.distributeStoreDia) {
				this.ruleForm.applyDec = ''
				this.ruleForm.storeUserId = ''
				this.ruleForm.store.address.address = ''
				this.ruleForm.store.address.name = ''
				this.ruleForm.store.address.phone = ''
				this.ruleForm.store.storeAddress = ''
				this.ruleForm.store.storeName = ''



			}
		}
	},

	created() {
		this.init()
		// this.getShopTEMU()
		// this.getShopTEMUID(12)

	},

	methods: {
		...mapActions('shopaccess', [
			'getLockShopID',
			'getUserInfo',
			'createWarehouse',
			'bindWarehouse',
			'searchWarehouse',//获取卖家帐号下所有仓库
			'getAllstore',//获取仓库帐号下所有仓库
			'getAllstoreALL', //获取系统内所有的仓库
			'sellerBindStore',//卖家帐号绑定仓库
			'unboundShop',//解绑商店
			'getShopAuthorization',
			'unboundStore',
			'getlazadaAuthorizationUrl',
			'getLazadaShop',
			'deleteWarehouse',
			'getShopSale',
			'getUserStock',
			'createPrivateStore',
			'getSellerPrivateStore'

		]),
		...mapActions('deduction', [
			'getStroeSeller',
		]),
		...mapActions('recharge', [
			'pointChange'
		]),
		...mapActions('order', [
			'getunprocessOrder'

		]),
		...mapMutations('login', [
			'SET_STORAGE_USERINFO',

		]),

		...mapMutations('shopaccess', [
			'SET_STORAGE_TTP',
			'GET_LAZADA_SHOP',
			'DELET_HAS_CLAIM_ALL',

		]),
		//
		changAuthoriedStore(val) {
			if (val == 'TEMU') {
				this.TEMUFormData = {
					shopId: '',
					shopName: '',
					shopSite: '0',
					shopType: '0',
					productToken: '',
					usOrderToken: '',
					euOrderToken: '',
					shopCurrency: '0', orderAppKey: "", //订单应用Key
					orderAppSecret: "", //订单应用Secret
					productAppKey: "", //产品应用Key
					productAppSecret: "", //产品应用Secret
					authType: '0', //授权类型:0-三方,1-自研
					localToken:"",//授权Token令牌
				}
				this.dialogFormVisibleTEMU = true;
			}
		},
		getTemuCountry(shopSite) {
			for (let i = 0; i < this.TEMUSite.length; i++) {
				if (shopSite == this.TEMUSite[i].value) {
					return this.TEMUSite[i].label;
				}
			}
		},
		//获取店铺信息TEMU(单个)
		getShopTEMUID(id) {
			var formdata = new FormData();
			formdata.append("shopId", id);
			formdata.append("shopType", 0);
			temu
				.getTemuAuthInfo(formdata)
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						res.data.shopCurrency += ''
						res.data.shopSite += ''
						res.data.shopType += ''
						this.TEMUFormData = res.data
						console.log(this.TEMUFormData,'this.TEMUFormData')
					} else {
						this.$message.warning(res.msg)
					}
				})
		},
		//删除店铺信息TEMU
		delShopTEMUID(data) {

			this.$confirm(this.$t('other.a2340'), this.$t("other.a142"), {
				confirmButtonText: this.$t('other.a2341'),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
			}).then(() => {
				temu
					.deleteTemuAuth(data, this.userId)
					.then(res => {
						if (res.code === 200) {
							console.log('desc', res.data)
							this.$message.success(this.$t('other.a210'))
							setTimeout(() => {
								location.replace('./index')
							}, 500)
						} else {
							this.$message.warning(res.msg)
						}
					})

			})
		},
		//更新店铺信息TEMU
		editShopTEMU(data) {
			console.log(data,'data')
			data.shopCurrency += ''
			data.shopSite += ''
			data.shopType += ''
			this.TEMUFormData = JSON.parse(JSON.stringify(data))
			this.TEMUFormData.authType = !this.TEMUFormData.authType?'0':'1'
			this.TEMUFormData.shopType = this.TEMUFormData.shopType+''
			this.dialogFormVisibleTEMU = true
		},
		//操作店铺信息TEMU
		changeTEMU(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.TEMUFormData.productToken = this.TEMUFormData.productToken?this.TEMUFormData.productToken.trim():this.TEMUFormData.productToken;
					this.TEMUFormData.usOrderToken = this.TEMUFormData.usOrderToken?this.TEMUFormData.usOrderToken.trim():this.TEMUFormData.usOrderToken;
					this.TEMUFormData.euOrderToken = this.TEMUFormData.euOrderToken?this.TEMUFormData.euOrderToken.trim():this.TEMUFormData.euOrderToken;
					this.TEMUFormData.orderAppKey = this.TEMUFormData.orderAppKey?this.TEMUFormData.orderAppKey.trim():this.TEMUFormData.orderAppKey;
					this.TEMUFormData.orderAppSecret = this.TEMUFormData.orderAppSecret?this.TEMUFormData.orderAppSecret.trim():this.TEMUFormData.orderAppSecret;
					this.TEMUFormData.productAppKey = this.TEMUFormData.productAppKey?this.TEMUFormData.productAppKey.trim():this.TEMUFormData.productAppKey;
					this.TEMUFormData.productAppSecret = this.TEMUFormData.productAppSecret?this.TEMUFormData.productAppSecret.trim():this.TEMUFormData.productAppSecret;
					this.TEMUFormData.localToken = this.TEMUFormData.localToken?this.TEMUFormData.localToken.trim():this.TEMUFormData.localToken;
					if (!this.TEMUFormData.id) {
						temu
							.saveTemuAuthInfo(this.TEMUFormData, this.userId)
							.then(res => {
								if (res.code === 200) {
									console.log('desc', res.data)
									this.$message.success(this.$t('other.a2623'))
									this.dialogFormVisibleTEMU = false
									this.getUserDetail()
									// setTimeout(() => {
									// 	location.replace('./index')
									// }, 500)
								} else {
									this.$message.warning(res.msg)
								}
							})
					} else {
						temu
							.updateTemuAuthInfo(this.TEMUFormData)
							.then(res => {
								if (res.code === 200) {
									console.log('desc', res.data)
									this.$message.success(this.$t('other.a2623'))
									this.dialogFormVisibleTEMU = false
									this.getUserDetail()
									// setTimeout(() => {
									// 	location.replace('./index')
									// }, 500)
								} else {
									this.$message.warning(res.msg)
								}
							})
					}
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		comfirmRemark() {
			this.remarkParams.remark = this.remarkName
			api2
				.updateShopRemark(this.remarkParams)
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						this.$message.success(this.$t('other.a2311'))
						setTimeout(() => {
							location.replace('./index')
						}, 200)
						this.init()
					} else {
						this.$message.warning(res.msg)
					}
				})

		},

		kvhmf(shopId) {
			this.remarkDia = true
			this.remarkParams.shopId = shopId
			this.remarkParams.userId = this.userId

		},

		hdknv(id) {
			const params = {
				'0': this.$t('other.a2298'),
				'1': this.$t('other.a1874'),
				'2': this.$t('other.a1875'),
				'3': this.$t('other.a1876')
			}

			return params[id]
		},

		hdknv(id) {
			const params = {
				'0': this.$t('other.a2298'),
				'1': this.$t('other.a1874'),
				'2': this.$t('other.a1875'),
				'3': this.$t('other.a1876')
			}

			return params[id]
		},

		bingAlliance() {
			console.log(this.invitationScan)
			shopaccessApi
				.bindLeagueStore({ invitationCode: this.invitationScan, userId: this.userId })
				.then(res => {
					if (res.code === 200) {
						this.$message.success(this.$t('other.a2312'))
						this.dialogVisible05 = false
						this.getUserInfo({ userId: this.userId })
					} else {
						this.$message.warning(res.msg)
					}
				})
		},

		getRules(id) {
			let storeRules = JSON.parse(localStorage.getItem('userInfo')).stores.filter(item => item.storeId == id)
			this.rechargeRulse = storeRules
			this.storeCharge = true

			console.log(storeRules)
		},

		generateDistrubuteStore() {
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					console.log('ruleForm', this.ruleForm)
					if (this.isChildrenStore) {//建私有仓子仓
						shopaccessApi
							.sellerAddPrivateStore({
								storeName: this.ruleForm.store.storeName,
								storeAddress: this.ruleForm.store.storeAddress,
								userId: this.ruleForm.userId,
								sellerId: this.ruleForm.storeUserId
							})
							.then(res => {
								if (res.code === 200) {
									this.$message.success(this.$t('other.a2313'))
									this.distributeStoreDia = false
								} else {
									this.$message.warning(res.msg)
								}
							})

					} else {//建分稍仓子仓

						shopaccessApi
							.addDistributionStore(this.ruleForm)
							.then(res => {
								if (res.code === 200) {
									this.$message.success(this.$t('other.a2314'))
									this.distributeStoreDia = false
								} else {
									this.$message.warning(res.msg)
								}
							})

					}

				} else {
					this.$message.warning(this.$t('other.a2385'))
					return false;
				}
			});

		},

		//卖家帐号新建分销子仓
		createDistributeStore(num, item) {
			console.log(num, item)
			this.distributeStoreDia = true
			if (num == 0) {//新建分销子仓
				this.isChildrenStore = false
				this.ruleForm.storeUserId = item.storeUserId
			} else if (num == 1) {//新建私有仓子仓
				this.isChildrenStore = true
				this.ruleForm.storeUserId = item.storeUserId
			}

			console.log(this.ruleForm)

		},

		createStoreByStore(num) {
			this.storeType = num
			if (num == 1) {
				this.textDesc = this.$t('other.a2316')
			}
			if (num == 3) {
				this.textDesc = this.$t('other.a2317')
			}
			this.dialogVisible02 = true
		},

		modify(item, index) {
			console.log(item, index)
			this.indexOne = index
		},

		comfirm(item, index) {
			item.userId = this.form.userId
			let ttp = /^0\.[0-9]{1,2}$|^0{1}$|^1{1}$|^1\.[0]{1,2}$/
			if (!ttp.test(item.rate)) {
				this.$message.warning(this.$t('other.a2318'))
				return
			}
			console.log(item, index)
			this.indexOne = null

			let parmas = {
				discountType: item.discountType,
				rate: item.rate,
				sellerId: item.sellerId,
				storeId: item.storeId,
				userId: item.userId


			}

			shopaccessApi
				.setSellerDiscount(parmas)
				.then(res => {
					if (res.code === 200) {
						console.log('resdata', res.data)
						this.$message.success(this.$t('other.a665'))

					}
				})
		},

		cancel(item, index) {
			console.log(index)
			shopaccessApi
				.deleteSellerDiscount({ discountId: item.discountId, storeId: item.storeId, userId: this.form.userId })
				.then(res => {
					if (res.code === 200) {
						this.$message.success(this.$t('other.a1232'))
						this.sellerDiscountList.splice(index, 1)
					}
				})
		},


		addDiscount() {
			let ttp = /^0\.[0-9]{1,2}$|^0{1}$|^1{1}$|^1\.[0]{1,2}$/

			if (!this.form.storeId) {
				this.$message.warning(this.$t('other.a2320'))
				return
			}

			// if(!ttp.test(this.form.rate)){
			// 	this.$message.warning(this.$t('other.a2318'))
			// 	return
			// }

			shopaccessApi
				.setSellerDiscount(this.form)
				.then(res => {
					if (res.code === 200) {
						console.log('resdata', res.data)
						this.$message.success(this.$t('other.a741'))
						this.discount = false
					}
				})


		},

		setDiscount(item) {
			console.log(item)
			this.discount = true
			this.form.seller = item.userName
			this.form.sellerId = item.userId
		},

		showDiscount(item) {
			console.log(item)
			this.warehoseValue = JSON.parse(localStorage.getItem('userInfo')).stores[0].storeId
			this.sellerId = item.userId
			let params = {
				sellerId: item.userId,
				storeId: this.warehoseValue,
				userId: JSON.parse(localStorage.getItem('userInfo')).userId

			}
			shopaccessApi
				.getSellerDiscount(params)
				.then(res => {
					if (res.code === 200) {
						console.log('卖家优惠', res.data)
						this.sellerDiscountList = res.data
						this.viewDiscount = true

					}
				})
		},

		showDiscountCopy() {
			let params = {
				sellerId: this.sellerId,
				storeId: this.warehoseValue,
				userId: JSON.parse(localStorage.getItem('userInfo')).userId

			}
			shopaccessApi
				.getSellerDiscount(params)
				.then(res => {
					if (res.code === 200) {
						console.log('卖家优惠', res.data)
						this.sellerDiscountList = res.data


					}
				})
		},

		vetifyAcount() {
			shopaccessApi
				.getDistributionStore({ userId: this.userId })
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
					} else {
						this.message.warning(res.msg)
					}
				})

			this.dialogVisible04 = true
		},

		viewPrivateAccount() {
			shopaccessApi
				.getDistributionStore({ userId: this.userId })
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						this.DiaLogPrivateStore = true
						this.privateStoreList = res.data
					} else {
						this.message.warning(res.msg)
					}
				})
		},



		checkStore() {
			shopaccessApi
				.checkPrivateStore({ userId: this.storeAccount })
				.then(res => {
					if (res.code === 200) {
						console.log(res.data)
						this.activeNum = 1
					} else {
						this.activeNum = 2
						this.$message.error(this.$t('other.a2323'))
					}
				})
		},

		checkChildrenWarehose() {
			shopaccessApi
				.checkChildrenStore({ storeName: this.storeName })
				.then(res => {
					if (res.code === 200) {
						console.log(res.data)
					}
				})
		},


		showChange(id) {
			console.log('payTypeOptions', this.payTypeOptions)
			let ttp = this.payTypeOptions.filter(p => {
				if (p.value == id) {
					return p
				}
			})
			if (ttp) {
				return ttp[0].label
			} else {
				return id
			}
		},
		//
		showStoreName(id) {
			return utils.showstoreNameBystoreId(id)
		},
		//获取积分变化明细
		getRecharge() {
			let params = {
				payType: this.pay_Value,
				offset: this.pagesize,
				page: this.page,
				sellerIds: this.sellerIdList,
				shopIds: this.shopIds,
				storeIds: this.storeList,
				end: this.value4[1],
				start: this.value4[0].slice(0, 10),
				userId: this.userId
			}
			console.log(params)
			api
				.getIntegralLog(params)
				.then(res => {
					if (res.code === 200) {
						console.log('收入支出', res.data)
						this.showChare = true
						this.pointsInfomation = res.data.logs
						this.pointsInfomationNum = res.data.count
						if (this.changType) {
							this.pointsInfomation_Copy = res.data.logs

						}
					}
				})
		},
		getDay(day) {
			var today = new Date();
			var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
			today.setTime(targetday_milliseconds); //注意，这行是关键代码
			var tYear = today.getFullYear();
			var tMonth = today.getMonth();
			var tDate = today.getDate();
			tMonth = this.doHandleMonth(tMonth + 1);
			tDate = this.doHandleMonth(tDate);
			return tYear + "-" + tMonth + "-" + tDate;
		},
		exportXmlCopy() {
			this.showChare = true
			this.changType = true
		},

		exportXml() {
			console.log(this.pointsInfomation)
			let params = {
				payType: this.pay_Value,
				offset: this.pagesize,
				page: null,
				sellerIds: this.sellerIdList,
				storeIds: this.storeList,
				end: this.value4[1],
				start: this.value4[0],
				userId: this.userId
			}
			api
				.getIntegralLog(params)
				.then(res => {
					if (res.code === 200) {
						let arr = []
						res.data.logs.forEach(p => {
							arr.push({
								'支付类型': this.showChange(p.payType),
								'支付单号': p.payOrderId,
								'支付积分': p.changeIntegral,
								'积分变化前': p.oldIntegral,
								'积分变化后': p.newIntegral,
								'收款方': this.showStoreName(p.storeId),
								'付款方': p.payWith,
								'时间': utils.renderTime(p.createTime),
							})
						})

						console.log(arr)
						utils.exportProcessedOrder(arr)
					}
				})
			console.log(params)
		},

		getAll() {

			if (this.chooseAll) {
				this.storeBindShopList.forEach(p => {
					p.checked = true
					this.getSellerList(p)
				})
			} else {
				this.storeBindShopList.forEach(p => {
					p.checked = false
					this.getSellerList(p)
				})
			}



		},

		getAllStore() {
			if (this.chooseStoreAll) {
				this.warehouse.forEach(p => {
					p.checked = true
					this.getStoreList(p)
				})
			} else {
				this.warehouse.forEach(p => {
					p.checked = false
					this.getStoreList(p)
				})
			}
		},

		getStoreList(item) {
			console.log(item)
			if (item.checked) {
				this.storeList.push(item.storeId)
				if (this.storeList.length > this.warehouse.length) {
					this.storeList = []
				}
				this.storeList.push(item.storeId)
				this.storeList = utils.unique(this.storeList)
			} else if (!item.checked) {
				this.storeList.forEach((p, index) => {
					if (p === item.storeId) {
						this.storeList.splice(index, 1)
					}
				})
			}
			console.log(this.storeList)
		},

		getSellerList(item) {

			if (item.checked) {
				this.sellerIdList.push(item.userId)
				if (this.sellerIdList.length > this.storeBindShopList.length) {
					this.sellerIdList = []
				}
				this.sellerIdList.push(item.userId)
				this.sellerIdList = utils.unique(this.sellerIdList)
			} else if (!item.checked) {
				this.sellerIdList.forEach((p, index) => {
					if (p === item.userId) {
						this.sellerIdList.splice(index, 1)
					}
				})

			}

			console.log(this.sellerIdList)
		},
		getTiem(time) {
			return utils.renderTime(time)
		},

		viewOption(item) {
			this.intergralDia = true

		},
		registore() {
			console.log(this.newObj)
			if (!this.newObj.country) {
				this.$message.warning(this.$t('other.a2324'))
				return
			}
			if (!this.newObj.storeName) {
				this.$message.warning(this.$t('other.a2325'))
				return
			}
			if (!this.newObj.password) {
				this.$message.warning(this.$t('other.a2326'))
				return
			}

			let ttp = JSON.parse(JSON.stringify(this.newObj.password))
			this.newObj.password = md5(this.newObj.password + 'seller'),

				shopaccessApi
					.createPrivateStore(this.newObj)
					.then(res => {
						if (res.code === 200) {
							console.log(res.data)
							let test = this.$t('other.a2327') + res.data.userId + this.$t('other.a2328') + ttp

							this.$confirm(test, this.$t('other.a2329'), {
								confirmButtonText: this.$t("other.a884"),
								type: 'success'
							}).then(() => {
								if (res.data) {
									this.privateStoreList.push(res.data)
								}
								this.newObj.password = ''
								this.newObj.country = ''
								this.newObj.storeName = ''
							})
						} else {
							this.$message.warning(res.msg)
							this.newObj.password = ''
							this.newObj.country = ''
							this.newObj.storeName = ''
						}
					})
			// this.dialogVisible04=false


		},

		JVNHF() {
			let arr = this.sistemAllstore.filter(p => {
				if (p.storeId !== 10100006) {
					return p
				}
			})
			return arr
		},
		//查看店铺销售情况
		viewShopSales(item) {
			this.shopsalesVisible = true
			this.getShopSale({
				end: utils.getRecentSevenDay(0),
				start: utils.getRecentSevenDay(-7),
				shopId: item.shopId,
				userId: this.userId
			})
		},
		//删除仓库
		deleteStore(item) {
			console.log(item)
			this.deleteWarehouse({
				storeId: item.storeId,
				userId: item.userId
			})
		},

		getEcharts() {
			console.log(document.getElementById('chartDom'))
			this.chatsRadios = echarts.init(document.getElementById('chartDom'))
			this.chatsRadios.setOption(this.storeCharge)
		},
		init() {
			// this.getStoreInfo() //获取绑定仓库按钮的选项
			if (this.userPos === 'STORE') {
				console.log(this.storeBindShopList)
				this.sellerIdList = this.storeBindShopList.map(p => {
					return p.userId
				})
				this.storeBindShopList = JSON.parse(localStorage.getItem('userInfo')).sellers
			}

			console.log(this.storeBindShopList)

			this.countryOption = utils.getCountryOption()
			this.otnmgv() //判断url中是否有授权的店铺Id
			// this.getLazadaShop_lazada() //获取lazada商店
			// this.getUserStock({account:"thstock"})
			let start = utils.getRecentSevenDay(-30)
			let end = utils.getRecentSevenDay(1)
			this.value4 = [start, end]


		},
		openWindow() {
			let url = 'https://www.yuque.com/dongtiandeyinghuochong/qtw9rm/puf5t2'
			window.open(url)
		},

		getShopAuthorization_lazada() {
			let url = "https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&redirect_uri=https://erp.shopsbu.com/erp/callBack/lazadaCallBack&client_id=123391&state=" + this.userId;
			window.open(url)
		},
		getShopAuthorization_shopify() {
			this.$refs.shopifyForm.validate((valid) => {
				if (valid) {
					console.log(this.shopifyForm)
					shopaccessApi
						.getshopifyurl(this.shopifyForm)
						.then(res => {
							if (res.code === 200) {
								console.log('desc', res.data)
								window.open(res.data)
							} else {
								this.$message.warning(res.msg)
							}
						})
				} else {
					return false;
				}
			})
		},



		getPurchaser() {
			accountApi
				.getBuyer({
					userId: this.userId
				})
				.then(res => {
					if (res.code === 200) {
						console.log(res.data)
						this.purchaseList = res.data
						this.purchaseDia = true
					} else {
						this.$message.warning(res.msg)
					}
				})
		},

		createBuyerAccount() {
			this.$refs.buyUser.validate((valid) => {
				if (valid) {
					if (this.buyUser.password !== this.buyUser.secondpassword) {
						this.$message.warning(this.$t('other.a1489'))
						return
					}

					let obj = JSON.parse(JSON.stringify(this.buyUser))
					obj.password = md5(obj.password + 'seller')
					console.log(obj)
					accountApi
						.addBuyer(obj)
						.then(res => {
							if (res.code === 200) {
								console.log('desc', res.data)
								let name = res.data.userId
								let pas = obj.secondpassword
								let text = this.$t('other.a1490') + name + this.$t('other.a1491') + pas
								this.$confirm(text, this.$t('other.a446'), {
									confirmButtonText: this.$t('other.a955'),
									cancelButtonText: this.$t('other.a146'),
									type: 'success'
								}).then(() => {
									this.buyerDia = false
								})

							} else {
								this.$message.warning(res.msg)
							}
						})
				} else {
					return false;
				}
			});
		},
		getLazadaShop_lazada() {
			const params = {
				userId: this.userId
			}
			this.getLazadaShop(params)
		},
		uniteStore01(item) {
			console.log(item.storeId)
			let params = {
				userId: this.userId,
				storeId: item.storeId
			}
			this.unboundStore({ payload: params, text: this.$t('shopaccess').UniteStoreSuccess })
			setTimeout(() => {
				location.replace('./index')
			}, 500)
		},
		handleSizeChange(val) {
			this.pagesize = Number(`${val}`)
			console.log('每面显示的数量', this.pagesize);
			this.handleCurrentChange()
		},



		gibmv() {
			this.value4[1] = utils.CurdateAddoneday(this.value4[1])
			console.log(this.value4)
			// let time=new Date(this.value4[1])
			// time=time.setDate(time.getDate()+1)
			// time=new Date(time)
			//   var Y = time.getFullYear()
			//   var M = time.getMonth() + 1
			//   var D = time.getDate()
			//   time = Y + (M < 10 ? "-0" : "-") + M + (D < 10 ? "-0" : "-") + D
			//   this.endTime=time
			//   console.log(time)
		},
		handleCurrentChange(val) {
			let num = Number(`${val}`)
			this.page = (num - 1) * this.pagesize
			this.getRecharge()
		},
		openAuthorization() {
			let url = location.href
			let baseUrl = ''

			shopaccessApi
				.getParnetUrl({
					partnerId: 27
				})
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						window.open(res.data)
					} else {
						this.$message.warning(res.msg)
					}
				})

			if (url.indexOf('dianxiaosheng') > -1) {
				baseUrl = 'https://partner.shopeemobile.com/api/v1/shop/auth_partner?id=843035&token=5c9174fc6006107dfb919c806da054e7725e35473afb4e0b7a943d61f9070620&redirect=https://erp.dianxiaosheng.com/index'
				window.open(baseUrl)
			} else if (url.indexOf('weanaly') > -1) {
				baseUrl = 'https://partner.shopeemobile.com/api/v1/shop/auth_partner?id=843035&token=ab433e8f80128cda181fc4cdad8a220ef72f58e4e0b9335ce52aa58020cc551b&redirect=https://erp.weanaly.com/index'
				window.open(baseUrl)
			} else if (url.indexOf('shopsbu') > -1) {
				baseUrl = 'https://partner.shopeemobile.com/api/v1/shop/auth_partner?id=843035&token=b1b5f7336c83f97eccb7dca3a93ff9756b16ef3809be2d9cca7c58ad39cba49d&redirect=https://erp.shopsbu.com/index'
				window.open(baseUrl)
			} else if (url.indexOf('shopsooo') > -1) {
				shopaccessApi
					.getParnetUrl({
						partnerId: JSON.parse(localStorage.getItem('userInfo')).partnerId
					})
					.then(res => {
						if (res.code === 200) {
							console.log('desc', res.data)
							window.open(res.data)
						} else {
							this.$message.warning(res.msg)
						}
					})
			}

		},


		checkPartner() {
			let url = 'http://' + location.host
			console.log('url,', url)
			newOrders
				.getPartnerId({
					url: url
				})
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						if (res.data && res.data.partnerId) {
							this.registerForm.partnerId = res.data.partnerId
						}
					} else {
						this.$message.warning(res.msg)
					}
				})
		},

		openAuthorizationCopy() {
			let url = location.href
			let baseUrl = 'https://partner.test-stable.shopeemobile.com/api/v1/shop/auth_partner?id=1001107&token=5a3b9c68e446b677ce46f273f1fece08e8e89dc7ddaf12ad672e87e11c0847ee&redirect=https://erp.shopsbu.com'
			console.log(url)
			window.open(baseUrl)

		},
		//页面创建时判断url中是否有shop_id
		otnmgv() {
			let newUrl = location.href
			if (newUrl.search("shop_id") == -1) {
				return
			} else {
				let arr = newUrl.split(/=/)
				let shopid = parseInt(arr[arr.length - 1])
				let params = {
					userId: this.userId,
					shopId: shopid
				}
				this.getLockShopID(params).then(res => {
					if (res.code === 200) {
						this.$confirm(this.$t('other.a2330'), this.$t("other.a142"), {
							confirmButtonText: this.$t('other.a145'),
							cancelButtonText: this.$t('other.a146'),
							type: 'success'
						}).then(() => {
							this.getUserInfo({ userId: this.userId })
						}).catch(() => {
							setTimeout(() => {
								location.replace('/index')
							}, 500)
						})
					} else {
						const confirmText = [res.msg + this.$t('other.a2331'), this.$t('other.a2332')]
						const newDatas = []
						const h = this.$createElement
						for (const i in confirmText) {
							newDatas.push(h('p', null, confirmText[i]))
						}
						this.$confirm(this.$t("other.a142"), {
							title: this.$t('other.a2333'),
							message: h('div', null, newDatas),
							showCancelButton: true,
							confirmButtonText: this.$t('other.a2334'),
							cancelButtonText: this.$t('other.a146'),
							type: 'error'
						}).then(() => {
							api
								.mandatorBind({
									force: true,
									shopId: shopid,
									userId: this.userId
								})
								.then(res => {
									if (res.code === 200) {
										this.$confirm(this.$t('other.a2330'), this.$t("other.a142"), {
											confirmButtonText: this.$t('other.a145'),
											type: 'success'
										}).then(() => {
											this.getUserInfo({ userId: this.userId })
										}).catch(() => {
											this.getUserInfo({ userId: this.userId })
										})
									}
								})

						}).catch(() => {
							setTimeout(() => {
								location.replace('/index')
							}, 500)
						})
					}
				})

			}
		},




		//判断当前帐号，获取当前帐号下的所有仓库
		getStoreInfo() {
			if (this.userPos === 'STORE') {
				this.getAllstore(this.userId)
			} else if (this.userPos === 'SELLER') {
				// this.searchWarehouse(this.userId)
				// this.getShopItems(this.userId)
				// this.getAllstoreALL({sellerName:this.userId})
				// this.getSellerPrivateStore({userId:this.userId})
			}
		},
		showRouter() {
			alert(this.userId)
			this.reload()
		},

		//国家转换
		getCountry(platform) {
			const country = {
				TW: this.$t('h5.DSX_index_tw'),
				PH: this.$t('h5.DSX_index_ph'),
				MY: this.$t('h5.DSX_index_my'),
				TH: this.$t('chat.Thailand'),
				SG: this.$t('chat.Singapore'),
				ID: this.$t('chat.Indonesia'),
				VN: this.$t('h5.DSX_index_vn'),
				BZ: this.$t('h5.DSX_index_bz'),
				CN: this.$t('other.a2335')
			}
			return country[platform]
		},

		changeUser(item) {
			console.log(item)
			shopaccessApi
				.updateStoreUsed({
					isUsed: item.isUsed,
					storeId: item.storeId,
					userId: this.userId

				})
				.then(res => {
					if (res.code === 200) {
						this.getUserDetail()
						if (item.isUsed) {
							this.$message.success(this.$t('other.a2336'))
						} else {
							this.$message.success(this.$t('other.a2337'))
						}
					}
				})
		},

		getUserDetail() {
			shopaccessApi
				.getUserInfo({ userId: JSON.parse(localStorage.getItem('userInfo')).userId })
				.then(res => {
					if (res.code === 200) {
						console.log('重新获取一次帐号的信息', res.data)
						this.DELET_HAS_CLAIM_ALL(res.data)
						let data = res.data
						if (data.shopeeShops || data.lazadaShops || data.tiktokShops || data.temuAuth) {
							localStorage.setItem('shophasAuthorization', true)
						} else {
							localStorage.setItem('shophasAuthorization', false)
						}
						if (data.userPos === 'STORE') {
							localStorage.setItem('shophasAuthorization', true)

						}

						this.GET_LAZADA_SHOP(data.lazadaShops)
						localStorage.setItem('userInfo', JSON.stringify(data))
						localStorage.setItem('shopIdInfo', JSON.stringify(data.shopeeShops))
						localStorage.setItem('warehouse', JSON.stringify(data.stores))
						localStorage.setItem('lazadashopId', JSON.stringify(data.lazadaShops))
						localStorage.setItem('temuAuth', JSON.stringify(data.temuAuth))
					}
				})
		},

		showStatus(tiem1, tiem2) {

			return utils.isDuringDate(tiem1, tiem2)
		},

		//国家转换
		getStatus(status) {

			let desc = ""
			if (status === 'NORMAL') {
				desc = this.$t('other.a1082')
			} else {
				desc = this.$t('other.a1911')
			}
			return desc
		},
		//切割时间
		getTime(time) {
			return utils.renderTime(time)
		},
		activeCurrent(index) {
			for (let i in this.isShow) {
				this.isShow[i] = false
			}
			console.log(this.isShow)
			this.isShow[index] = true
		},

		//创建仓库
		lockShop(num) {
			const ttp = {
				userId: this.userId,
				userName: this.userName,
				storeName: this.storeName,
				storeAddress: this.value,
			}

			const params = {
				userId: this.userId,
				shopId: this.shopIdttp

			}

			if (num == 0) {
				this.getLockShopID(params)
				this.dialogVisible01 = false
				setTimeout(() => {
					location.replace('./index')
				}, 500)
			} else if (num === 1) {//新建子仓
				if (!this.userName || !this.storeName || !this.value) {
					this.$message.warning(this.$t('other.a2338'))
					return
				}
				console.log('子仓', ttp)
				if (this.storeType == 3) {
					ttp.invitationCode = this.invitationCode
					shopaccessApi
						.addLeagueStore(ttp)
						.then(res => {
							if (res.code === 200) {
								this.$message.success(this.$t('other.a2339'))
								this.dialogVisible02 = false
								this.getUserInfo({ userId: this.userId })
							} else {
								this.$message.warning(res.msg)
							}
						})
				}

				if (this.storeType == 1) {
					this.createWarehouse(ttp).then(res => {
						if (res.code === 200) {
							this.$message.success(this.$t('other.a2386'))
							this.dialogVisible02 = false
							this.getUserInfo({ userId: this.userId })
						} else {
							this.$message.success(res.msg)
						}
					})
				}




			} else if (num === 2) {
				const ttp = {
					userId: this.userId,
					storeId: this.stroeIDvalue
				}
				this.sellerBindStore({ payload: ttp, text: this.$t('shopaccess').bangdinSuccess })
				this.dialogVisible03 = false
				setTimeout(() => {
					location.replace('./index')
				}, 500)
			}



		},
		//提前获取订单数据
		getOrderInfo() {
			const params = {
				userId: this.userId,
				start: this.start_time,
				end: this.end_time,
			}

			this.getunprocessOrder(params)
		},
		//获取最近7天的时间
		getRecentSevenDay(day) {
			var today = new Date();
			var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
			today.setTime(targetday_milliseconds); //注意，这行是关键代码
			var tYear = today.getFullYear();
			var tMonth = today.getMonth();
			var tDate = today.getDate();
			tMonth = this.doHandleMonth(tMonth + 1);
			tDate = this.doHandleMonth(tDate);
			return tYear + "-" + tMonth + "-" + tDate;
		},
		doHandleMonth(month) {
			var m = month;
			if (month.toString().length == 1) {
				m = "0" + month;
			}
			return m;
		},
		//刷新当前页面
		upDatePages() {
			location.reload()
		},
		getShopAddress(id) {
			shopaccessApi
				.getShopAddress({
					shopId: id,
					userId: this.userId
				})
				.then(res => {
					if (res.code === 200) {
						console.log('店铺地址', res.data)
						this.addressData = res.data.response.address_list ? res.data.response.address_list : []
						this.addressDia = true
					} else {
						this.$message.warning(res.msg)
					}
				})
		},
		//解绑商店
		unboundshopByselleer(id) {
			const params = {
				shopId: id,
				userId: this.userId
			}
			this.$confirm(this.$t('other.a2340'), this.$t("other.a142"), {
				confirmButtonText: this.$t('other.a2341'),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
			}).then(() => {
				console.log(params)
				shopaccessApi
					.unboundShop(params)
					.then(res => {
						if (res.code === 200) {
							this.$message.success(this.$t('other.a210'))
							setTimeout(() => {
								location.replace('./index')
							}, 500)

						} else {
							this.$message.warning(res.msg)
						}
					})

			})

		},

		tableRowClassName({ row, rowIndex }) {
			if (rowIndex === 1) {
				return 'warning-row';
			} else if (rowIndex === 3) {
				return 'success-row';
			}
			return '';
		}
	}


}
</script>

<style scoped>
.teDialog /deep/.el-dialog{
	margin-top: 5vh !important;
}
.teDialog .teForm{
	max-height:65vh;
	overflow-y:auto;
}
</style>

<style>
.shopaccess {
	/* flex: 1;
	margin: 60px 0 0 235px; */
}

.shop-detail-title {
	width: 100%;
	padding-left: 20px;
	height: 30px;
	text-align: left;
	line-height: 30px;
	font-size: 20px;
	font-weight: bold;

}

.shopaccess .main-header {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	height: 40px;
	background-color: #eee;

	margin: 10px;
	padding: 0 10px;
}

.shopaccess .uijk {
	margin-left: 5px;
}

.shopaccess .kvhnkf {
	font-size: 16px;
	font-weight: normal;
}

.shopaccess .gknv {
	width: 180px;
	height: 180px;
	overflow: hidden;
}

.el-icon-edit {
	color: #409eff;
	font-size: 16px;
	margin-left: 10px;
	cursor: pointer;

}

.shopaccess .recharge_item {
	border-bottom: 1px #eee solid;
}



.shopaccess .omog {
	display: inline-block;
	width: 76px;
	text-align: left;
}

.shopaccess .shop-desc {
	display: inline-block;
	background-color: #409eff;
	padding: 5px 20px;
	text-align: center;
	margin: 0 15px;
	border-radius: 5px;
	color: #fff;
	cursor: pointer;
}

.shopaccess .userInfo {
	margin: 20px 10px;
	border-radius: 5px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
}

.shopaccess .userInfo-item {
	padding: 20px 15px;
	font-size: 14px;
}

.shopaccess .ilnv {
	display: flex;
	justify-content: center;
}

.shopaccess .lgkjg {
	display: inline-block;
	width: 15px;
	height: 15px;
	border-radius: 2px;
	background-color: red;
}

.shopaccess .ehng {
	display: inline-block;
	width: 15px;
	height: 15px;
	border-radius: 2px;
	background-color: aquamarine;
}

.shopaccess .shop-detail {
	margin: 20px 10px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	border-radius: 5px;
	box-sizing: border-box;
	padding: 5px 15px;
}

.shopaccess .shop-item-title {
	display: flex;
	justify-content: space-between;
	border-bottom: 1px #eee solid;
	padding: 15px 0;
}

.shopaccess .ttp {
	width: 199px;
	height: 56px;
	font-size: 14px;
	line-height: 56px;
	text-align: center;
}

.shopaccess .list-item {
	display: inline-block;
	width: 30%;
	font-size: 12px;
	padding: 15px 0;

	text-align: center;


}

.el-tooltip__popper {
	font-size: 16px !important;
}

.shopaccess .el-table .warning-row {
	background: oldlace;
}

.shopaccess .el-table .success-row {
	background: #f0f9eb;
}

.shopaccess .btn {

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.echartBox {
	display: flex;
	margin: 20px 10px;
	box-sizing: border-box;
	padding: 5px 15px;
	justify-content: space-between;
	box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.shopaccess .shop-item-list {
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px #eee solid;
}

.shopaccess .shop-item-list .cancel {
	background-color: #f56c6c;
	display: inline-block;
	width: 30px;
}

.shopaccess .itemlist {
	padding: 10px 0;
}

.shopaccess .itemlist:nth-child(6) {
	cursor: pointer;
	color: #007EE5;
}

.shopaccess .title-item {
	display: inline-block;
	width: 30%;
	text-align: center;
}

.country-choose {
	width: 100%;
	margin-top: 10px;
}
</style>
